import Popup from './Popup.vue';
import withInstall from '@/shared/withInstall';

export const XPopup = withInstall(Popup);
export default XPopup;
